
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_9ckv7_muh77_9",
  "container-override": "awsui_container-override_9ckv7_muh77_14",
  "active": "awsui_active_9ckv7_muh77_14",
  "header": "awsui_header_9ckv7_muh77_34",
  "flexible": "awsui_flexible_9ckv7_muh77_41",
  "handle": "awsui_handle_9ckv7_muh77_45",
  "refresh": "awsui_refresh_9ckv7_muh77_48",
  "header-content": "awsui_header-content_9ckv7_muh77_52",
  "settings": "awsui_settings_9ckv7_muh77_56",
  "fixed": "awsui_fixed_9ckv7_muh77_64",
  "resizer": "awsui_resizer_9ckv7_muh77_68"
};
  